/** Fares are handled in pesewas (100 pesewas = GH₵1) to keep maths in integers. */
export const FARE = {
  /** Roughly 2026 Accra trotro fares: ~GH₵5 to get on, plus distance. */
  basePesewas: 500,
  perHundredMetresPesewas: 100,
  perfectStopTipPesewas: 100,
} as const;

export function farePesewas(metresTravelled: number, multiplier = 1): number {
  const distancePart = Math.floor(metresTravelled / 100) * FARE.perHundredMetresPesewas;
  return Math.round((FARE.basePesewas + distancePart) * multiplier);
}

export function formatCedis(pesewas: number): string {
  const sign = pesewas < 0 ? '−' : '';
  return `${sign}GH₵${(Math.abs(pesewas) / 100).toFixed(2)}`;
}
